import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import download1 from '../images/download1.png';
import '../styles/FloatingBanner.css';

function FloatingBanner() {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="floating-banner">
      <Link to="/download">
          <img src={download1} alt="Download" className="download-image2" />
      </Link>
        <button className="close-button" onClick={handleClose}>×</button>
    </div>
  );
}

export default FloatingBanner;
